import React from 'react';
import { Link } from 'react-router-dom';
import './WelcomePage.css'; // Make sure the path to your CSS file is correct

// Import the background image from your src folder.
// The path is relative to this JS file.
import welcomeBg from '../assets/images/1.png'; 

const WelcomePage = () => {
    // Create a style object to apply the background image
    const headerStyle = {
        backgroundImage: `url(${welcomeBg})`
    };

    return (
        <div className="welcome-page-container">
            <header className="welcome-header" style={headerStyle}>
                <div className="welcome-overlay"></div>
                <div className="welcome-content">
                    <div className="app-logo float-end">
                        {/* Ensure your logo image is in the public/assets/images folder */}
                        <img src={process.env.REACT_APP_API_BASE_URL + '/logo_files/cricket_manager_logo5.png'} alt="Cricket Manager Logo" /> 
                    </div>
                    <h1 className='welcomeheading'>CRICKET MANAGER</h1>
                    <p className="tagline">Your Club. Your Control. All in One App.</p>
                    
                    <div className="feature-showcase-grid">
                        <div className="feature-box">
                            <h4><i className="fas fa-gamepad me-2"></i>Game & Scoring</h4>
                            <ul>
                                <li><i className="fas fa-check-circle me-2"></i>Schedule Matches</li>
                                <li><i className="fas fa-check-circle me-2"></i>Define Teams</li>
                                <li><i className="fas fa-check-circle me-2"></i>Editable Scorecard</li>
                                <li><i className="fas fa-check-circle me-2"></i>Special Rules</li>
                            </ul>
                        </div>
                        <div className="feature-box">
                            <h4><i className="fas fa-users-cog me-2"></i>Club Management</h4>
                            <ul>
                                <li><i className="fas fa-check-circle me-2"></i>Public Registration</li>
                                <li><i className="fas fa-check-circle me-2"></i>Secure Login</li>
                                <li><i className="fas fa-check-circle me-2"></i>Roles: Admin/Member</li>
                                <li><i className="fas fa-check-circle me-2"></i>Player Profiles</li>
                            </ul>
                        </div>
                        <div className="feature-box">
                            <h4><i className="fas fa-chart-line me-2"></i>Financials & Stats</h4>
                            <ul>
                                <li><i className="fas fa-check-circle me-2"></i>Wallet & Ledgers</li>
                                <li><i className="fas fa-check-circle me-2"></i>Contributions</li>
                                <li><i className="fas fa-check-circle me-2"></i>Expenses</li>
                                <li><i className="fas fa-check-circle me-2"></i>Career Stats</li>
                            </ul>
                        </div>
                    </div>

                    <div className="cta-buttons">
                        <Link to="/login" className="btn btn-primary btn-lg me-3">Login to Your Club</Link>
                        <Link to="/club_register" className="btn btn-primary btn-lg">Register Your Club</Link>
                    </div>
                </div>
            </header>
        </div>
    );
};

export default WelcomePage;